module.exports = __webpack_public_path__ + "static/media/dancingMan.19687148.png";